import { FormControl, InputLabel, OutlinedInput } from '@mui/material';
import React, { forwardRef, useImperativeHandle } from 'react';
import { useForm } from 'react-hook-form';
const ForgotForm = forwardRef(function (props, ref) {
    const { onSubmit } = props;
    const { register, handleSubmit, formState } = useForm({
        defaultValues: {
            email: '',
        },
    });
    useImperativeHandle(ref, () => ({
        handleSubmitForm: () => {
            handleSubmit((data) => onSubmit({
                email: data.email,
            }))();
        },
    }));
    return (React.createElement("form", null,
        React.createElement(FormControl, { error: !!formState.errors.email, margin: 'normal', variant: 'outlined', fullWidth: true },
            React.createElement(InputLabel, { htmlFor: 'outlined-username' }, "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430"),
            React.createElement(OutlinedInput, Object.assign({ id: 'outlined-email', label: '\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430', fullWidth: true, placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0432\u043E\u044E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443\u044E \u043F\u043E\u0447\u0442\u0443' }, register('email', {
                required: true,
                pattern: /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/,
            }))))));
});
export default ForgotForm;
